import React from "react"

import ProjectInvite from "./../../invite/ProjectInvite"

import { Link } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUserPlus } from "@fortawesome/free-solid-svg-icons"

class InviteTesters extends React.Component{
    render(){
        const { id } = this.props
        return(
            <div className="manageSection" id="inviteTesters">
                <div className="manageHeader">
                    <div className="svgContainer">
                        <FontAwesomeIcon icon={faUserPlus} />
                    </div>
                    <div className="introText">
                        <h1 className="headerTitle">Invite Testers</h1>
                        <p>Set your project to <b>private</b>, and invite your friends to test your game!<br />
                            (Your friends have to be <Link to="/invite">invited</Link> to the platform first)</p>
                    </div>
                </div>
                <ProjectInvite id={id}/>
            </div>
        )
    }
}

export default InviteTesters